import Booking from '@solvhealth/types/interfaces/Booking';
import { PAYMENT_FULFILLED, PAYMENT_PENDING } from '../../constants/payment';
import { isEmptyObject } from '../../core/util/object';
import { isEmptyString } from '../../core/util/string';

const isInvoicePending = (status: any) => status === PAYMENT_PENDING;
const isInvoiceFulfilled = (status: any) => status === PAYMENT_FULFILLED;
const hasInvoice = (booking: any) => !isEmptyObject(booking) && !isEmptyString(booking.invoice_id);

const isPaymentMethodAddedForCurrentBooking = (booking: Booking) => {
  return !!(
    booking?.authorizedPaymentMethodStripeId ?? booking?.authorized_payment_method_stripe_id
  );
};

// faith can allow a patient to bypass payment from the facesheet modal in the queue
const isPaymentBypassed = (booking: any) =>
  booking?.isPaymentBypassed ?? booking?.is_payment_bypassed ?? false;

export {
  hasInvoice,
  isInvoiceFulfilled,
  isInvoicePending,
  isPaymentBypassed,
  isPaymentMethodAddedForCurrentBooking,
};
